module.exports = __webpack_public_path__ + "img/sutong.5ea0a331.png";